export class ServingUtil {
  static getDynamicImage(url?: string, size?: number, cropCircle: boolean = false, pngFormat: boolean = false): string | undefined {
    if (!url || !url.includes('googleusercontent')) return url;
    const parts = [];
    if (size != null) {
      parts.push(`s${size}`);
    }
    if (cropCircle) {
      parts.push('cc');
    }
    if (pngFormat) {
      parts.push('rp');
    }
    if (parts.length === 0) return url;

    const instructions = parts.join('-');
    const eqIndex = url.indexOf('=');
    if (eqIndex === -1) {
      return `${url}=${instructions}`;
    } else {
      return url.substring(0, eqIndex + 1) + instructions;
    }
  }
}

// Original
// https://lh3.googleusercontent.com/a-/AOh14GhNY65s6pWW3BHRBybkjEvtj1lhyNRVQDpruTSE=s96-c

// After code runs
// https://lh3.googleusercontent.com/a-/AOh14GhNY65s6pWW3BHRBybkjEvtj1lhyNRVQDpruTSE=s96-c=s96-cc-rp
